define.alias("ember-basic-dropdown/components/basic-dropdown-content", "calendar/components/basic-dropdown-content");